export enum eTrackerPeriod {
  Custom = 0,
  Weekly = 1,
  Biweekly = 2,
  Monthly = 3,
  Quarterly = 4,
  Yearly = 5
}

export const TrackerPeriodList = [
  { name: "Weekly", mode: eTrackerPeriod.Weekly },
  { name: "Biweekly", mode: eTrackerPeriod.Biweekly },
  { name: "Monthly", mode: eTrackerPeriod.Monthly },
  { name: "Quarterly", mode: eTrackerPeriod.Quarterly },
  { name: "Yearly", mode: eTrackerPeriod.Yearly },
  { name: "Custom", mode: eTrackerPeriod.Custom },
];




// WEBPACK FOOTER //
// ./src/app/enums/tracker-period.enum.ts